/* eslint-disable quotes */
/* eslint-disable camelcase */
import _ from 'lodash';
import moment from 'moment';
import { formatPhone, getPromotion } from './customer';
import { getFirebaseCustomerId } from '../api/firebase/firebaseAuthentication';
import store from '../redux/store';
import {
  API_SEND_ORDER,
  Basket,
  DELIVERY_FLEET_CONFIGURATION_TYPE,
  MENU_ELEMENT_MEASUREMENT_UNIT,
  Option,
  OPTION_CATEGORY_TYPE,
  OptionList,
  ORDER_FLOW_TYPE,
  CUSTOMER_CANCEL_PHASE_CONTACTING,
  ORDER_PHASE,
  ORDER_TYPE_CLICK_AND_COLLECT,
  ORDER_TYPE_CLICK_AND_COLLECT_LABEL,
  ORDER_TYPE_CLICK_AND_SEAT,
  ORDER_TYPE_CLICK_AND_SEAT_LABEL,
  ORDER_TYPE_DELIVERY,
  ORDER_TYPE_DELIVERY_LABEL,
  PAYMENT,
  PICKUP_STATUS,
  Product,
  SHOP_CANCEL_AND_REFUND,
  SHOP_CANCEL_PHASE_CONTACTING,
} from '../constants';
import {
  DEFAULT_SEND_ORDER_ERROR,
  generateId,
  getCustomerTableNb,
  getTimezone,
  isObjectNotNull,
  removeUndefined,
} from '.';
import { isQrCode } from './config';
import {
  showCartModal,
  showMessageModal,
  showOrderModal,
  showOrderStatus,
  updateOrderTime,
} from '../redux/actions';
import {
  addCardToExistingCustomer,
  confirmPaymentIntent,
  createCustomer,
  createPayment,
  deleteCustomerPaymentCardBackend,
  retrieveCard,
  sendGoogleAnalytics,
  sendPostRequest,
  updateCustomerHubrise,
  updateUser,
} from "../api";
import { fetchShopOrderSlots } from "../api/shops";
import { ERROR_NAMES } from "./error";
import { analyticsEvents } from "./firebaseAnalytics";
import { updateTraceId } from "../redux/actions/orderAction";
interface ApiErrorResponse {
  errorName?: string;
  errorMessage?: string;
}
import {
  ensureBoolean,
  ensureInteger,
  ensureNumber,
  ensureString,
  ensureStringOrNumber,
} from './common';
import { logHighError, logLowLog, logMediumError } from './logger';

export { roundNumber } from './number';
export const showMessageModalWithLoading = (setLoading, message) => {
  setLoading(false);
  store.dispatch(showMessageModal(message));
};

export const attachPaymentMethodToCustomer = async (card) => {
  const { user, userConnected } = store.getState().userReducer;
  const { id } = card;
  const customerId = getFirebaseCustomerId();
  try {
    const { stripeCustomerId, email } = user;
    const data = {
      cardId: id,
      customerId,
    };
    const cardOnStripe = await retrieveCard(data,);
    if (!cardOnStripe || !cardOnStripe.customer) {
      const data = { card, customerId };
      logLowLog('Ading card to customer', data);
      if (stripeCustomerId) {
        data['stripeCustomerId'] = stripeCustomerId;
        await addCardToExistingCustomer(data);
      } else {
        data['email'] = email;
        await createCustomer(data);
      }
    }
    logLowLog('Successfully creating payment intent');
    return true;
  } catch (error) {
    const errorMessage = String(error);
    if (!errorMessage.includes('not be used again')) {
      logMediumError(`Could not attach payment method to customer ${error}`);
    } else if (userConnected) {
      deleteCustomerPaymentCardBackend(id);
    }
    throw error;
  }
};

export const sendOrderClick = async ({
  paymentType,
  card,
  stripe,
  setLoading,
  phoneObj,
  setChoosePayment,
}) => {
  let chargeId = null;
  const { user, userConnected } = store.getState().userReducer;
  const { email, stripeCustomerId, customerId } = user;
  try {
    logLowLog('Sending new order');
    const { servicePrice } = store.getState().shopReducer;
    const { orderTime } = store.getState().orderReducer;
    const { configHours } = store.getState().configurationReducer;
    const { customAccountId } = servicePrice;
    const {
      shopId,
      orderType,
      totalProductPriceWithPromo,
      totalPriceOrder,
      address: customerAddress,
    } = store.getState().pendingOrderReducer;
    const traceId = generateId();
    store.dispatch(updateTraceId(traceId));
    const finalOrder = {};
    const promotion = getPromotion(totalProductPriceWithPromo);
    finalOrder['paymentType'] = paymentType;
    finalOrder['timezone'] = getTimezone();
    finalOrder['canal'] = isQrCode() ? 'QRCODE' : 'WEBAPP';
    if (orderType === ORDER_TYPE_DELIVERY) {
      finalOrder['instruction'] = customerAddress?.instruction;
      finalOrder['street2'] = customerAddress?.street2;
    }
    if (orderType === ORDER_TYPE_CLICK_AND_SEAT && isQrCode()) {
      finalOrder['tableNb'] = getCustomerTableNb();
    }
    finalOrder['date'] = configHours.hideScheduledTime
      ? moment().format()
      : moment(orderTime?.date).format();
    if (promotion && !promotion.minBasketPrice) {
      finalOrder['promotion'] = promotion;
    }
    if (userConnected) {
      const numero = formatPhone(user.numero);
      await updateCustomerHubrise(
        { address: customerAddress, numero },
        customerId,
      );
      await updateUser(customerId, {
        numero: numero || '',
        phone: phoneObj,
      });
    }

    if (paymentType === PAYMENT.TYPE_STRIPE && totalPriceOrder) {
      try {
        logLowLog('Creating payment');
        const amount = Math.round(totalPriceOrder * 100);
        const transferGroup = moment.utc(finalOrder['date']).format('X');
        const intentData = {
          amount,
          description: `${shopId} - ${email}`,
          currency: 'eur',
          customer: stripeCustomerId,
          capture_method: 'manual',
          confirmation_method: 'manual',
          payment_method: card.id,
          confirm: true,
          setup_future_usage: 'on_session',
          on_behalf_of: customAccountId,
          transfer_data: {
            destination: customAccountId,
          },
          transfer_group: transferGroup,
        };
        const data = { intentData, shopId, customerId };
        const charge = await createPayment(data);
        const { id, status, client_secret } = charge;
        finalOrder['chargeId'] = id;
        chargeId = id;
        if (userConnected) {
          attachPaymentMethodToCustomer(card);
        }
        if (status === 'requires_source_action') {
          logLowLog(`Requiring confirmation for payment ${id}`);

          const { error, paymentIntent } =
            await stripe.handleCardAction(client_secret);

          logLowLog(`Success confirmation for payment ${id}`);

          if (error) {
            logHighError(JSON.stringify(error), { finalOrder });
            throw error;
          } else if (paymentIntent.status === 'requires_confirmation') {
            logLowLog(`Asking for 3D SECURE ${id}`);
            await confirmPaymentIntent(paymentIntent.id, customerId);
            logLowLog(`Successfully verifying with 3D SECURE ${id}`);
          }
        }
      } catch (error) {
        const errorMessage = String(error);
        if (userConnected) {
          attachPaymentMethodToCustomer(card);
        }
        if (
          !errorMessage.includes('insufficient') &&
          !errorMessage.includes('declined') &&
          !errorMessage.includes('support') &&
          !errorMessage.includes('incorrect') &&
          !errorMessage.includes('A network')
        ) {
          logHighError(`Custom authorization failed ${JSON.stringify(error)}`);
        }
        store.dispatch(
          showMessageModal(
            'Le paiement en ligne a échoué. Veuillez réessayer ou changer de carte bancaire.',
          ),
        );
        setLoading(false);
        return;
      }
    }
    logLowLog(`Sending order to firebase ${JSON.stringify(finalOrder)}`, {
      chargeId,
    });
    await sendOrder({
      customerId,
      setLoading,
      order: finalOrder,
      setChoosePayment,
    });
  } catch (error: unknown) {
    setLoading(false);
    setChoosePayment(false);
    const apiError = error as ApiErrorResponse;
    const errorMessage =
      apiError?.errorMessage ?? String(error ?? DEFAULT_SEND_ORDER_ERROR);
    if (
      apiError?.errorName ===
      ERROR_NAMES.PRODUCT_NOT_AVAILABLE_AT_SELECTED_DATE &&
      (apiError as any).data
    ) {
      store.dispatch(
        showMessageModal(
          'Votre panier contient des produits qui ne sont pas disponibles pour la date choisie. Prochaines dates disponibles :',
          {
            hours: (apiError as any).data,
            text: 'Disponibilités',
            showCancel: false,
            buttonName: 'Ok',
            activationRange: true,
          },
        ),
      );
      return;
    }

    const isNetworkError = errorMessage.includes('network');
    const logPrefix = isNetworkError ? 'Network error' : 'Order error';
    logHighError(`${logPrefix} when sending order: ${errorMessage}`, {
      chargeId,
    });
    if (paymentType === PAYMENT.TYPE_STRIPE && chargeId) {
      //  refundCustomerPaymentIntent(customerId, chargeId);
    }
    store.dispatch(showMessageModal(errorMessage));
  }
};

export const sendOrder = async ({
  customerId,
  setLoading,
  order,
  setChoosePayment,
}) => {
  const {
    orderType,
    address,
    totalPriceOrder,
    managementFee,
    commande = null,
    shopId
  } = store.getState().pendingOrderReducer;
  const { traceId } = store.getState().orderReducer;
  const userServicePrice = address.deliveryPrice;
  const { date, promotion, paymentType } = order;
  const headers = {
    "X-trace-Id": traceId ?? null
  }
  if (isObjectNotNull(commande)) {
    const { companyId } = store.getState().configurationReducer;
    logLowLog(
      `DISHOP WEBAPP - Sending order. companyId=${companyId}, shopId=${shopId}, customerId=${customerId}`,
      order, null, { traceId }
    );
    try {
      await sendPostRequest(
        API_SEND_ORDER(companyId, customerId),
        order,
        false,
        headers
      );
    } catch (error: unknown) {
      const apiError = error as ApiErrorResponse;
      if (apiError?.errorName?.includes(ERROR_NAMES.SHOP_SLOT_ERRORS)) {
        logLowLog("ShopSlotIsUnavailable error detected, fetching new slots", null, null, { traceId });
        const timezone = getTimezone();
        const currentDay = moment();
        const newSlots = await fetchShopOrderSlots(
          companyId,
          customerId,
          currentDay.format('YYYY-MM-DD'),
          timezone,
        );

        const availableSlot = newSlots?.find((slot: any) => !slot.disabled);
        if (availableSlot) {
          store.dispatch(updateOrderTime(availableSlot));
          logLowLog(
            `Updated order time to new available slot: ${availableSlot.value}`,
          );
        } else {
          store.dispatch(updateOrderTime(null));
          logLowLog('No available slots found');
        }
      }
      throw error;
    }
  } else {
    showMessageModalWithLoading(
      setLoading,
      "Votre commande n'a pas pu être envoyée, car votre panier ne contenait aucun produit.",
    );
    store.dispatch(showCartModal(false));
    logHighError(
      `Error in shop ${shopId}. Basket was empty when sending order for user ${order.id}.`,
      { order }, null, { traceId }
    );
    return;
  }
  store.dispatch(showCartModal(false));
  store.dispatch(showOrderModal(true));
  store.dispatch(showOrderStatus(order.chargeId));
  setLoading(false);
  setChoosePayment(false);
  const items = [];
  _.map(commande, (product) => {
    const { key, name, sectionName, nb, price, position } = product;
    items.push({
      id: key,
      name,
      category: sectionName,
      position,
      quantity: nb,
      price,
    });
  });
  const promoCode = promotion?.promoCode ?? '';
  const day = moment(date).format('dddd');
  const hour = moment(date).format('HH:mm');
  const analyticsData = {
    coupon: promoCode,
    currency: 'EUR',
    shipping: userServicePrice,
    tax: managementFee,
    value: totalPriceOrder,
    items,
  };
  sendGoogleAnalytics('purchase', analyticsData);
  analyticsEvents.logPurchase(
    promoCode,
    userServicePrice,
    managementFee,
    paymentType,
    totalPriceOrder,
    orderType,
    address?.city,
    day,
    hour,
    order.isSchedule,
  );
};

export const isOrderRefunded = (order) =>
  order?.cancellation?.cancelReason === SHOP_CANCEL_AND_REFUND ||
  (order?.cancellation?.cancelReason === SHOP_CANCEL_PHASE_CONTACTING &&
    order?.paymentType === PAYMENT.TYPE_STRIPE) ||
  (order?.cancellation?.cancelReason === CUSTOMER_CANCEL_PHASE_CONTACTING &&
    order?.paymentType === PAYMENT.TYPE_STRIPE) ||
  (order?.cancellation != null &&
    order?.paymentType === PAYMENT.TYPE_STRIPE &&
    (Number(order?.userCancelServicePrice) || 0) === 0) ||
  order?.status === ORDER_PHASE.REFUND;

export const getEstimationTime = (order) => {
  const {
    orderType,
    expectedDropoffDate = null,
    datePreparationEnded = moment(),
    estimatedDeliveryDate = moment(),
  } = order;
  if (expectedDropoffDate) {
    return moment(expectedDropoffDate);
  }
  return orderType === ORDER_TYPE_DELIVERY
    ? moment(estimatedDeliveryDate)
    : moment(datePreparationEnded);
};

export const getStatus = (order) => {
  if (_.isEmpty(order)) return '';
  const {
    status,
    orderFlowType = ORDER_FLOW_TYPE.CLASSIC,
    pickupStatus,
    userNameDep,
    orderType,
    tableNb,
    delivery = {},
  } = order;

  switch (status) {
    case ORDER_PHASE.CONTACTING:
      return handleContacting(
        pickupStatus,
        userNameDep,
        orderType,
        orderFlowType,
        delivery,
      );
    case ORDER_PHASE.PREPARING:
      return handlePreparing(pickupStatus, userNameDep, orderType);
    case ORDER_PHASE.DELIVERING:
      return userNameDep &&
        delivery?.nature !== DELIVERY_FLEET_CONFIGURATION_TYPE.DELIVEROO
        ? `${userNameDep} se dirige vers vous`
        : `Votre commande est en cours de livraison` +
        ", plus que quelques instants avant de déguster votre plat.";
    case ORDER_PHASE.TAKEAWAY:
      return `La commande est prête. Venez vite la chercher avant qu’elle ne refroidisse.`;
    case ORDER_PHASE.WAITER:
      return `Votre serveur arrive avec votre commande${tableNb ? ` à la table ${tableNb}` : ""
        }.`;
    default:
      return '';
  }
};

const handleContacting = (
  pickupStatus,
  userNameDep,
  orderType,
  orderFlowType,
  delivery,
) => {
  if (
    orderFlowType === ORDER_FLOW_TYPE.REVERSE &&
    orderType === ORDER_TYPE_DELIVERY
  ) {
    return pickupStatus === PICKUP_STATUS.ORDER_NOT_CURRENTLY_SUPPORTED
      ? delivery?.searchDriver
        ? 'Nous cherchons actuellement un livreur partenaire avant de contacter votre restaurant préféré.'
        : `Nous avons bien reçu votre commande. La recherche d'un partenaire de livraison commencera 30 minutes avant l'heure de livraison souhaitée.`
      : `Le restaurateur a bien reçu votre commande. Nous attendons sa validation. ${userNameDep ? `${userNameDep} sera votre livreur.` : ""
      }`;
  }
  return 'Le restaurateur a bien reçu votre commande. Nous attendons sa validation.';
};

const handlePreparing = (pickupStatus, userNameDep, orderType) => {
  if (orderType === ORDER_TYPE_CLICK_AND_COLLECT) {
    return 'Votre commande est en cours de préparation, vous pourrez la récupérer d’ici peu.';
  } else if (orderType === ORDER_TYPE_CLICK_AND_SEAT) {
    return 'Votre commande est en cours de préparation et sera servie sous peu.';
  }
  switch (pickupStatus) {
    case PICKUP_STATUS.ORDER_NOT_CURRENTLY_SUPPORTED:
      return 'Votre commande est en cours de préparation, elle partira en livraison d’ici peu.';
    case PICKUP_STATUS.DRIVER_ON_THE_WAY_TO_RESTAURANT:
      return `Votre commande est en cours de préparation, votre livreur ${userNameDep} se dirige vers le restaurant.`;
    default:
      return 'Votre commande est en cours de préparation.';
  }
};

export const getOrderTypeLabel = (orderType: string) => {
  return orderType === ORDER_TYPE_DELIVERY
    ? ORDER_TYPE_DELIVERY_LABEL
    : orderType === ORDER_TYPE_CLICK_AND_COLLECT
      ? ORDER_TYPE_CLICK_AND_COLLECT_LABEL
      : ORDER_TYPE_CLICK_AND_SEAT_LABEL;
};

const emptyNullArray = ['', null];

const formatOption = (option: any): Option => {
  return {
    additional: ensureBoolean(option.additional),
    key: ensureString(option.key, false), // TODO Default
    label: ensureString(option.label, false), // TODO Default
    name: ensureString(option.name, false), // TODO Default
    nb: ensureInteger(option.nb),
    position: ensureInteger(option.position, [], 0),
    price: ensureNumber(option.price), // TODO Default
    priceRef: ensureNumber(option.priceRef, emptyNullArray),
    itemRecursiveKey: ensureString(option.itemRecursiveKey), // TODO Default
    categoryKey: ensureString(option.categoryKey), // TODO Default
    productKey: ensureString(option.productKey, true, emptyNullArray),
    ref: ensureString(option.ref, true, emptyNullArray),
    subcategories: ensureString(option.subcategories, true, emptyNullArray),
    sectionKey: ensureString(option.sectionKey, true, emptyNullArray),
    type: ensureString(option.type),
    value: ensureNumber(option.value, [], 0), // TODO Default
    isFree: ensureBoolean(option.isFree),
    productPromotionAmount: ensureNumber(
      option.productPromotionAmount,
      emptyNullArray,
    ),
    productMarketingCampaignKey: ensureString(
      option.productMarketingCampaignKey,
      false,
      [null],
    ),
    cashRegisterSubcategoriesHistory: Array.isArray(
      option.cashRegisterSubcategoriesHistory,
    )
      ? (_.filter(
        _.map(
          option.cashRegisterSubcategoriesHistory,
          (cashRegisterSubcategoriesHistory) =>
            ensureString(cashRegisterSubcategoriesHistory, false),
        ),
        (cashRegisterSubcategoriesHistory) =>
          !!cashRegisterSubcategoriesHistory,
      ) as string[])
      : undefined,
  };
};

const formatOptionList = (optionList: any): OptionList => {
  let options = null;
  if (!optionList) {
    return undefined;
  }
  if (typeof optionList?.options === 'object') {
    const formattedOptions = {};

    for (const optionKey of Object.keys(optionList.options)) {
      formattedOptions[optionKey] = formatOption(optionList.options[optionKey]);
    }
    options = formattedOptions;
  }
  return removeUndefined({
    categoryKey: ensureString(optionList.categoryKey, false), //TODO Default
    categoryId: ensureString(optionList.categoryId, true, emptyNullArray),
    categoryMultiple: ensureBoolean(
      optionList.categoryMultiple,
      emptyNullArray,
    ),
    categoryName: ensureString(optionList.categoryName, true, emptyNullArray),
    categoryPosition: ensureInteger(
      optionList.categoryPosition,
      emptyNullArray,
    ),
    categoryType: ensureString(optionList.categoryType, true, emptyNullArray),
    ref: ensureString(optionList.ref, true, emptyNullArray),
    isMarketingCampaignProductOffered: ensureBoolean(
      optionList.isMarketingCampaignProductOffered,
    ),
    options,
  });
};

const formatProduct = (product: any): Product => {
  return removeUndefined({
    isLoyaltyProduct: ensureBoolean(
      product.isLoyaltyProduct,
      emptyNullArray,
      null,
    ),
    points: ensureNumber(product.points, emptyNullArray, null),
    boughtPrice: ensureNumber(product.boughtPrice, emptyNullArray, null),
    categories: ensureString(product.categories, false, [null], null),
    description: ensureString(product.description, true, emptyNullArray),
    disabled: ensureBoolean(product.disabled, emptyNullArray),
    disabledCC: ensureBoolean(product.disabledCC, emptyNullArray),
    disabledCS: ensureBoolean(product.disabledCS, emptyNullArray),
    disabledDelivery: ensureBoolean(product.disabledDelivery, emptyNullArray),
    instruction: ensureString(product.instruction, true, emptyNullArray),
    height: ensureNumber(product.height, emptyNullArray),
    image: ensureString(
      product.image,

      true,
      emptyNullArray,
    ),
    items: Array.isArray(product.items)
      ? _.map(
        _.filter(product.items, (item) => item !== null),
        (item) => formatOptionList(item),
      )
      : undefined,
    key: ensureString(product.key, false),
    logo: ensureString(product.logo, true, emptyNullArray),
    name: ensureString(product.name, true, emptyNullArray),
    type: ensureString(product.type, true, emptyNullArray),
    nb: ensureInteger(product.nb, [], 0),
    position: ensureNumber(product.position, emptyNullArray, 0),
    preparationTime: ensureStringOrNumber(product.preparationTime, true, [
      null,
    ]),
    price: ensureNumber(product.price), // TODO Default ?
    fullPrice: ensureNumber(product.fullPrice, emptyNullArray),
    productPrice: ensureNumber(product.productPrice, emptyNullArray),
    optionsPrice: ensureNumber(product.optionsPrice, emptyNullArray),
    productPromotionAmount: ensureNumber(
      product.productPromotionAmount,
      emptyNullArray,
    ),
    priceRef: ensureNumber(product.priceRef, emptyNullArray),
    productKey: ensureString(product.productKey, false, [null]),
    ref: ensureString(product.ref, true, emptyNullArray),
    sectionKey: ensureString(product.sectionKey, true, emptyNullArray),
    sectionName: ensureString(product.sectionName, true, emptyNullArray),
    shopId: ensureString(product.shopId),
    unit:
      product.unit === null ||
        Object.values(MENU_ELEMENT_MEASUREMENT_UNIT).includes(product.unit)
        ? product.unit
        : undefined,
    unitPrice: ensureNumber(product.unitPrice), // TODO Default ?
    width: ensureNumber(product.width, emptyNullArray),
    productPromotionCode: ensureString(
      product.productPromotionCode,
      true,
      emptyNullArray,
    ),
    volume: ensureString(product.volume),
    stock: ensureNumber(product.stock),
    productMarketingCampaignKey: ensureString(
      product.productMarketingCampaignKey,
      false,
      [null],
    ),
    isFakeProduct: ensureBoolean(product.isFakeProduct, [], false),
  });
};

export const formatBasket = (basket: any): Basket => {
  const formattedBasket = {};

  for (const productId of Object.keys(basket)) {
    formattedBasket[productId] = formatProduct(basket[productId]);
  }

  return formattedBasket;
};

export const isCategoryOptionProductType = (element) => {
  return element?.type === OPTION_CATEGORY_TYPE.PRODUCT;
};

export const removeBasketItemsForCampaign = async (campaignKey: string) => {
  const { deletePendingOrderBasketItem } = await import('../api/pendingOrder');
  const { commande } = store.getState().pendingOrderReducer;
  const {
    user: { customerId },
  } = store.getState().userReducer;
  if (!commande || !campaignKey || !customerId) return;
  const keysToDelete = Object.entries(commande)
    .filter(
      ([, product]) =>
        (product as any)?.productMarketingCampaignKey === campaignKey,
    )
    .map(([key]) => key);
  await Promise.allSettled(
    keysToDelete.map((key) => deletePendingOrderBasketItem(customerId, key)),
  );
};

export const pushBngmBasketItems = async (basketItems: any[]) => {
  const { updatePendingOrderBasket } = await import('../api/pendingOrder');
  if (!basketItems?.length) return;
  const {
    user: { customerId },
  } = store.getState().userReducer;
  const { shopId } = store.getState().shopReducer;
  if (!customerId) return;
  const batch: Record<string, any> = {};
  for (const item of basketItems) {
    const { fullKey, ...product } = item;
    batch[fullKey] = { ...product, shopId };
  }
  await updatePendingOrderBasket(customerId, batch);
};